module.exports = __webpack_public_path__ + "static/img/4.1b3ef5d9.png";